import { Component } from '@angular/core';
import { TranslationService } from '../../core/services/translation.service';
import { GlobalService } from '../../core/services/global.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {


    currentYear = new Date().getFullYear();
    currentLanguage = 'en';
    
    constructor(public global: GlobalService) {
        
    }
     
    
}
